import clsx from 'clsx'; // Import clsx for conditional class names
import React from 'react';
import Icon from '../icon/Icon.web';
import type { IconName } from '../icon/icon-paths-24x24';

interface MenuItemProps {
  iconName: IconName;
  label: string;
  onClick: () => void;
  selected?: boolean;
  disabled?: boolean;
}

const MenuItem: React.FC<MenuItemProps> = ({
  iconName,
  label,
  onClick,
  selected = false,
  disabled = false,
}) => {
  return (
    <div
      className={clsx(
        'cometchat-calls-more-menu-item',
        selected && 'cometchat-calls-more-menu-item--selected',
        disabled && 'cometchat-calls-more-menu-item--disabled',
      )}
      onClick={() => {
        if (!disabled) {
          onClick();
        }
      }}
      role="menuitem"
      tabIndex={disabled ? -1 : 0}
      aria-selected={selected}
      aria-disabled={disabled}
      onKeyDown={e => {
        if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
          onClick();
        }
      }}>
      <Icon
        name={iconName}
        size={24}
        fill="var(--cometchat-calls-text-color-secondary)"
      />{' '}
      <span className="cometchat-calls-more-menu-item-label">{label}</span>
    </div>
  );
};

export default MenuItem;
